const getDistanceToStore = (dist1, dist2, unit) => {
  const { latitude: latitude1, longitude: longitude1 } = dist1;
  const { latitude: latitude2, longitude: longitude2 } = dist2;

  const [lat1, lon1, lat2, lon2] = [
    latitude1,
    longitude1,
    latitude2,
    longitude2,
  ].map((dist) => (typeof dist === "string" ? parseFloat(dist) : dist));
  if (!lat1) return "N/A";
  const radlat1 = (Math.PI * lat1) / 180;
  const radlat2 = (Math.PI * lat2) / 180;
  const theta = lon1 - lon2;
  const radtheta = (Math.PI * theta) / 180;
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist);
  dist = ((dist * 180) / Math.PI) * 60;
  // default to km.
  dist = dist * 1.85327;

  if (unit === "mile") {
    dist = dist / 1.609344;
  }
  return parseFloat(parseFloat(dist).toFixed(1)); // defaults to miles
};

export default getDistanceToStore;
